import { Box, Typography } from '@mui/material';
import JoinButton from 'components/pages/Competition/JoinButton';
import Grid from '@mui/material/Grid';
import Paper from 'components/system/Paper';
import colors from 'styles/colors';
import { useParams } from 'react-router-dom';

const RestrictedTabContent = ({ message, showButton, competition }) => {
  const { id: competitionId } = useParams();
  return (
    <Grid item xs={12}>
      <Paper>
        <Box
          p={3}
          sx={{
            textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: colors.text.primary,
              marginBottom: '16px',
            }}
          >
            {message}
          </Typography>
          {showButton ? (
            <JoinButton
              id={competitionId}
              styles={{
                minWidth: 60,
                width: 100,
                marginBottom: '8px',
                padding: '6px 12px',
              }}
              competition={competition}
            />
          ) : null}
        </Box>
      </Paper>
    </Grid>
  );
};

export default RestrictedTabContent;
